module.exports = __webpack_public_path__ + "static/media/trello.d07b34fb.png";